import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoAssetsIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 24.7217,
			y: 26.8633,
			width: 72,
			height: 78.6667,
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 29.3887,
			y: 41.9727,
			width: 29.3333,
			height: 2,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 29.3887,
			y: 48.6406,
			width: 56.6667,
			height: 2,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 29.3887,
			y: 55.75,
			width: 56.6667,
			height: 2,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.3887 34.8633L34.4998 37.9744M34.4998 34.8633L31.3887 37.9744",
			stroke: "white",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86.2793,
			y: 77.084,
			width: 16.4444,
			height: 18.6667,
			fill: "#C9D8FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.0552,
			y: 65.75,
			width: 52,
			height: 18.6667,
			fill: "#C9D8FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9458 71.9727L23.6125 78.6393M23.6125 71.9727L16.9458 78.6393",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4458 14.4727L31.1125 21.1393M31.1125 14.4727L24.4458 21.1393",
			stroke: "#F385FF",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.445 56L107.945 59.5M107.945 56L104.445 59.5",
			stroke: "#F385FF",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 103.333,
			cy: 67,
			rx: 1.33333,
			ry: 1,
			fill: "#F385FF"
		})
	]
});
export default SvgNoAssetsIllustration;
